import {exportSvg as Icon__small__exportSvg} from '../Icon__small/Icon__small--export.js';

export var exportIcon = {
  name: 'export',
  category: 'icon',
  colorable: true,
  svg: Icon__small__exportSvg,
};
